import PasswordGenerator from "../utils/PasswordGenerator";

export default class BackofficeCustomersForm {

    constructor() {
        //this.bindEvents();
        this.initializeSelect2();
        this.initializeValidation();
        this.initializeCheckboxToggle();
        this.initializePasswordGeneration();
    }

    initializeSelect2() {
        // Initialize select2 for the entity multiple select with search functionality
        $('.entities-select').select2({
            width: '100%',
            allowClear: true,
            closeOnSelect: false,
            minimumResultsForSearch: 10, // Show search box only if there are more than 10 options
        });
    }

    initializeValidation() {
        window.validationData = {
            'customer[first_name]': {required: true},
            'customer[last_name]': {required: true},
            'customer[email]': {required: true},
            'customer[phone]': {phone_number_fr: true},
        };
    }

    initializeCheckboxToggle() {
        const checkbox = $('#customer_has_all_entities_access');
        const entitySelectContainer = $('#entity-select-container');
        const entitySelect = $('.entities-select');
        
        const toggleEntitySelect = () => {
            if (checkbox.is(':checked')) {
                entitySelect.prop('disabled', true);
                entitySelect.prop('required', false);
                entitySelectContainer.hide();
            } else {
                entitySelect.prop('disabled', false);
                entitySelect.prop('required', true);
                entitySelectContainer.show();
            }
        };
        
        // Initial state
        toggleEntitySelect();
        
        // On checkbox change
        checkbox.on('change', toggleEntitySelect);
    }

    initializePasswordGeneration() {
        $('#generate_password_btn').on('click', () => {
            const password = PasswordGenerator.generate();
            $('#customer_password').val(password);
            $('#customer_password_confirmation').val(password);
            $('#generated_password_display').val(password);
        });
    }

    onDataChanged(data) {
    }

    onDestroy() {
        // Clean up Select2 to prevent memory leaks
        $('.entities-select').select2('destroy');
        $('#customer_has_all_entities_access').off('change');
        $('#generate_password_btn').off('click');
    }
}